import { FormValues } from 'business/shift-report/report/pages/ReportEdit/components/report-metadata-drawer';
import { parseReportDateString } from 'business/shift-report/report/services/timeOperations';
import { parseTaskDateString } from 'business/shift-report/task/services/timeOperations';
import {
  GetNewReportFieldsQuery,
  ShiftReportChartViewFragment,
} from 'generated/graphql';

const getShiftStartDate = (
  shiftId: string,
  date: string,
  shifts: GetNewReportFieldsQuery['shifts'],
) => {
  const shiftMetadata = shifts.find((value) => value.id === shiftId);
  if (!shiftMetadata) {
    return null;
  }
  return parseReportDateString(date, shiftMetadata.startTime);
};

const getShiftStartTimeDiff = (
  currentShiftReport: ShiftReportChartViewFragment,
  targetValues: Required<Pick<FormValues, 'date' | 'shiftId'>>,
  shifts: GetNewReportFieldsQuery['shifts'],
) => {
  const targetShiftStartDate = getShiftStartDate(
    targetValues.shiftId,
    currentShiftReport.date.toString(),
    shifts,
  );

  const currentShiftStartDate = getShiftStartDate(
    currentShiftReport.shift.id,
    currentShiftReport.date.toString(),
    shifts,
  );

  if (!targetShiftStartDate || !currentShiftStartDate) {
    return null;
  }

  return targetShiftStartDate.diff(currentShiftStartDate);
};

export const getUpdatedTasks = (
  currentShiftReport: ShiftReportChartViewFragment,
  targetValues: Required<Pick<FormValues, 'date' | 'shiftId'>>,
  shifts: GetNewReportFieldsQuery['shifts'],
) => {
  const dayDiff = targetValues.date.diff(
    parseReportDateString(currentShiftReport.date.toString()),
    'days',
  );

  const shiftStartDiff = getShiftStartTimeDiff(
    currentShiftReport,
    targetValues,
    shifts,
  );

  let updatedTasks: ShiftReportChartViewFragment['tasks'] = [];
  if (dayDiff !== 0) {
    updatedTasks = currentShiftReport.tasks.map((task) => {
      return {
        ...task,
        startDate: parseTaskDateString(task.startDate).add(dayDiff, 'days'),
        endDate: parseTaskDateString(task.endDate).add(dayDiff, 'days'),
      };
    });
  }

  if (shiftStartDiff && shiftStartDiff !== 0) {
    updatedTasks = (
      updatedTasks.length ? updatedTasks : currentShiftReport.tasks
    ).map((task) => {
      return {
        ...task,
        startDate: parseTaskDateString(task.startDate.toString()).add(
          shiftStartDiff,
          'milliseconds',
        ),
        endDate: parseTaskDateString(task.endDate.toString()).add(
          shiftStartDiff,
          'milliseconds',
        ),
      };
    });
  }

  return updatedTasks;
};
